import React from 'react';
import { Container } from 'react-bootstrap';
import { AdminMenuManagement } from '../../components/admin';
import { AdminMenuProvider } from '../../context/AdminMenuContext';

const AdminMenuManagementPage = () => {
  return (
    <AdminMenuProvider>
      <Container fluid className="py-4">
        <AdminMenuManagement />
      </Container>
    </AdminMenuProvider>
  );
};

export default AdminMenuManagementPage;

